import { useEffect, useState } from "react";
import { getMyAccessProfileV2 } from "../../utils/appointment-utils";
import { MassagedProfile } from "../../utils/bridges/methods";

export function useMyAccessProfileV2({
  clinicId,
}: {
  clinicId?: string;
} = {}) {
  const [data, setData] = useState<MassagedProfile>();

  useEffect(() => {
    const profile = getMyAccessProfileV2({ clinicId });
    setData(profile);
  }, [clinicId]);

  return {
    data: data,
  };
}
